import { render, staticRenderFns } from "./ReportStatuses.vue?vue&type=template&id=61fe8318&scoped=true&"
import script from "./ReportStatuses.vue?vue&type=script&lang=js&"
export * from "./ReportStatuses.vue?vue&type=script&lang=js&"
import style0 from "./ReportStatuses.vue?vue&type=style&index=0&id=61fe8318&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fe8318",
  null
  
)

export default component.exports